import AdminLayout from '../../components/admin/AdminLayout';
import ClientMessagingHub from '../../components/admin/ClientMessagingHub';

export default function ClientInbox() {
  return (
    <AdminLayout>
      <div className="max-w-5xl mx-auto p-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900 mb-1">Client Messaging</h1>
          <p className="text-gray-500">
            View incoming messages from clients and send direct messages to your Workday clients.
          </p>
        </div>

        <ClientMessagingHub />
      </div>
    </AdminLayout>
  );
}
